export default __webpack_public_path__ + "static/media/arrow-img.96079d0d.png";